require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-hyper-personalisation.json") })
        }
      }, "path---services-hyper-personalisation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-hyper-personalisation!./.cache/json/services-hyper-personalisation.json
// module id = 1482
// module chunks = 231608221292675